import { ReactElement, useState } from 'react';
import { iInstalmentFormValues } from '@services/InstalmentService';
import { tile } from '@interfaces/interfaces';
import { DropdownMenu, Modal, TextInput, TileRadioAccessible, Alert } from '@components';
import { Field, useFormikContext } from 'formik';
import QuestionIcon from '../../../../images/question_small.svg';
import InfoIcon from '../../../../images/info.svg';
import styles from './InstalmentStep8.module.scss';

function InstalmentStep8(): ReactElement {
  const { values }: { values: iInstalmentFormValues } = useFormikContext();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const TILE_DATA: tile[] = [
    {
      body: 'Yes',
      value: 'true',
    },
    {
      body: 'No',
      value: 'false',
    },
  ];
  const COUNTRY_DROPDOWN = [
    {
      value: 'Abstudy',
      display: 'Abstudy',
    },
    {
      value: 'Carer Allowance',
      display: 'Carer Allowance',
    },
    {
      value: 'Disaster Recovery Payment',
      display: 'Disaster Recovery Payment',
    },
    {
      value: 'Family Tax Benefit',
      display: 'Family Tax Benefit',
    },
    {
      value: 'Other',
      display: 'Other',
    }
  ];
  const clickOpenModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const instalmentDeductedTitle = (
    <span>
      Would you like your instalments deducted from your Centrelink payments via Centrepay?
      {' '}
      <button type="button" onClick={clickOpenModal} className={styles.iconContainer}>
        <img src={QuestionIcon} className={styles.iconButton} alt="help icon" />
      </button>
    </span>
  );

  const centrepayModalInfo = (
    <div>
      <p>Centrepay is a free and voluntary bill paying service which allows you to pay bills directly from your Centrelink payments.</p>
      <br />
      <p>If you choose to pay via Centrepay, your instalments will be taken out of your Centrelink payment each fortnight.</p>
    </div>
  );

  const centrepayCheck = (
    <div>
      <p><strong>IMPORTANT</strong></p>
      <p>If you want to pay your instalments using Centrepay, <strong>don’t complete this form.</strong></p>
      <br />
      <p>Call us on
        {' '}
        <a href="tel:0392008111" title="Fines Victoria phone number">
          03 9200 8111
        </a>
        {' '}
        between 8:00 am and 6:00 pm weekdays except public holidays. This is the quickest and easiest way to set up your payment arrangement using Centrepay.
      </p>
      <br />
      <p>If you complete this form, we will still need to talk to you before we can set up the payment arrangement using Centrepay as the payment method.</p>
      <br />
      <p>This is because there are certain rules that must be followed when using Centrepay to pay your instalments.</p>
    </div>
  );

  return (
    <div>
      <span className="vfH2">Centrelink</span>
      <Field name="receiveCenterlinkPayments" component={TileRadioAccessible} tileData={TILE_DATA} title="Do you receive any Centrelink payments?" orientationRow isMandatory />
      {values.receiveCenterlinkPayments === 'true' && <Field name="instalmentDeducted" component={TileRadioAccessible} tileData={TILE_DATA} title={instalmentDeductedTitle} orientationRow isMandatory />}
      {isModalOpen && <Modal show close={closeModal} title="What is Centrepay?" content={centrepayModalInfo} />}
      {values.receiveCenterlinkPayments === 'true' && values.instalmentDeducted === 'true' && <Field name="centrelinkPaymentType" component={DropdownMenu} displayText={COUNTRY_DROPDOWN} title="What type of Centrelink payment do you receive?" isMandatory defaultOption />}
      {values.receiveCenterlinkPayments === 'true' && values.instalmentDeducted === 'true' && values.centrelinkPaymentType === 'Other' && <Field name="specifyPaymentType" component={TextInput} title="Please specify" orientationRow isMandatory />}
      {values.receiveCenterlinkPayments === 'true' && values.instalmentDeducted === 'true' && <Field name="centrelinkRefNo" component={TextInput} title="Centrelink Reference Number (CRN)" orientationRow isMandatory />}
      {values.receiveCenterlinkPayments === 'true' && values.instalmentDeducted === 'true' && <Field name="fortnightlyPaymentAmount" component={TextInput} title="How much can you pay fortnightly?" type="number" orientationRow isMandatory />}
      {values.receiveCenterlinkPayments === 'true' && values.instalmentDeducted === 'true' && <Field name="centrepayCheck" component={Alert} message={centrepayCheck} theme="info" icon={InfoIcon} orientationRow isMandatory="false" />}
    </div>
  );
}

export default InstalmentStep8;
